import { type PaletteMode, type ThemeOptions } from '@mui/material';

function getVisibleScrollbarStyles(mode: PaletteMode) {
  const isDark = mode === 'dark';

  return {
    colorScheme: isDark ? ('dark' as const) : ('light' as const),
    // this is to make the scroll bar always visible.
    // it will hide if there is no overflow.
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '2px solid #ffffff00',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    '&::-webkit-scrollbar:horizontal': {
      height: '11px',
    },
    '&::-webkit-scrollbar:vertical': {
      width: '8px',
    },
  };
}

export function getMixins(mode: PaletteMode): ThemeOptions['mixins'] {
  return {
    visibleScrollbar: getVisibleScrollbarStyles(mode),
    toolbar: {
      minHeight: 60,
    },
  };
}
